import React from 'react';
import WatchReview from '../watchReview'


function PansLab(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/MmjNWosw9xk" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss 'Pan's Labyrinth'."
            />
        )
    }   

export default PansLab;